import React, { useEffect, useState, useContext } from 'react';
import { BiSolidEditAlt } from 'react-icons/bi';
import { CiEdit } from 'react-icons/ci';
import { FaEdit, FaRegWindowClose } from 'react-icons/fa';
import { IoNewspaperOutline, IoSearchSharp } from 'react-icons/io5';
import { MdDeleteForever } from 'react-icons/md';
import Breadcrumb from '../components/Breadcrumb';
import { TiTick } from 'react-icons/ti';
import { TopologyService } from '../api/Topology.service';
import { CountryModal } from '../Types/Topology_case';
import Select from 'react-dropdown-select';
import { DataContext } from '../context/DataProvider';
import { Link, useSearchParams } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import ReactPaginate from 'react-paginate';
import { GrFormNext, GrFormPrevious } from 'react-icons/gr';
import DatePicker from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
const NewTopology = () => {
  const [savePage, setSavePage] = useState(1);
  const [Type, setType] = useState('null');
  const [FromDate, setFromDate] = useState(new Date());
  const [ToDate, setToDate] = useState(new Date());
  const {
    expire,
    expireToken,
    tokenLogin,
    isTokenExpired,
    fetchRefreshToken,
    edame,
  } = useContext(DataContext);
  const [pageSize, setPageSize] = useState(30);
  const [Country, setCountry] = useState([]);
  const [State, setState] = useState([]);
  const [City, setCity] = useState([]);
  // const [isloading, setisLoading] = useState(true);
  const [listLocation, setListLocation] = useState([]);
  const [listLocationcount, setListLocationcount] = useState(0);
  const [search, setSearch] = useState('');
  const [SearchPage, setSearchPage] = useState(1);
  const [SearchResultLocation, setSearchResultLocation] = useState([]);
  const [SearchResultLocationcount, setSearchResultLocationcount] = useState(0);
  const [valuecountry, setValuecountry] = useState({});
  const [valueState, setValueState] = useState([]);
  const [valueCity, setValueCity] = useState([]);
  const [StateforSelect, setStateForSelect] = useState([]);
  const [CityforSelect, setCityForSelect] = useState([]);
  const [searchParams, setsearchParams] = useSearchParams();
  const [openModal, setOpenModal] = useState(false);
  const [openModalEdit, setopenModalEdit] = useState(false);
  const [locationInfo, setLocationInfo] = useState({
    sectionID: 0,
    LawID: 0,
    locationIds: '',
  });

  function deHilight(str) {
    return str
      .replaceAll(/\n/g, ' ')
      .replaceAll('</e>', ' ')
      .replaceAll('</b>', ' ')
      .replaceAll('<e>', ' ')
      .replaceAll('<b>', ' ')
      .replaceAll('\x9D', '  ')
      .replaceAll(' ', '  ');
  }

  const page: any = searchParams.get('page');
  // const refresh = localStorage.getItem("Refreshtoken");
  let rowNumber = page ? (page - 1) * pageSize : 0;
  // const [expire,setExpire]=useState(false)

  // const [Info,setInfo]=useState({})

  // console.log("user",jwtDecode(token).userName)
  const token = localStorage.getItem('AccessToken');
  // console.log("time", Date.now())
  // console.log("expire",jwtDecode(token).exp * 1000)

  const fetchCountry = async () => {
    await fetch(`${process.env.REACT_APP_BASE_URL}/api/Data/Locations?type=5`, {
      // mode:"no-cors"
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        // console.log('country', data);
        setCountry(data);
      });
    // .finally(() => setisLoading(false));
  };
  const FetchState = async () => {
    await fetch(`${process.env.REACT_APP_BASE_URL}/api/Data/Locations?type=6`, {
      // mode:"no-cors"
      // headers: {
      //   Authorization: `Bearer ${token}`,
      // }
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        // console.log('state', data);
        setState(data);
      });
    // .finally(() => setisLoading(false));
  };
  const FetchCity = async () => {
    await fetch(`${process.env.REACT_APP_BASE_URL}/api/Data/Locations?type=7`, {
      // mode:"no-cors"
      // headers: {
      //   Authorization: `Bearer ${token}`,
      // }
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        setCity(data);
      });
    // .finally(() => setisLoading(false));
  };
  const FetchLocation = async (currentpage: number) => {
    // console.log(expire);
    await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/Admin/ListLocation?size=${pageSize}&page=${currentpage}`,
      {
        // mode:"no-cors"
        // headers: {
        //   Authorization: `Bearer ${token}`,
        // }
      },
    )
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        // console.log(data),
        setListLocation(data.data), setListLocationcount(data.count);
        // }).catch((error) => {
        //   console.log(error)
        //   window.location.reload();
      });
  };
  const fetchSearchLocation = async () => {
    // if (token) {
    //   if (!expire) {

    await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/Admin/ListLocation?search=${search}&size=${pageSize}&page=${SearchPage}`,
      {
        // headers: {
        //   Authorization: `Bearer ${token}`,
        // }
      },
    )
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        // console.log('search', data),
        setSearchResultLocation(data.data),
          setSearchResultLocationcount(data.count);
      });
  };

  useEffect(() => {
    FetchLocation(page ? page : 1);
    fetchCountry();
    FetchCity();
    FetchState();
  }, [pageSize, page]);

  const [arrCountry, setArrcounrty] = useState([]);
  const [arrState, setArrState] = useState([]);
  const [arrCity, setArrCity] = useState([]);

  const InfoEdit = (item) => {
    console.log(item.LocationIDs);

    try {
      let a = [];
      let s = [];
      let t = [];
      setOpenModal(true);
      if (item.LocationIDs !== null) {
        const x = item.LocationIDs.split(',');
        for (let i = 0; i < x.length; i++) {
          const c = x[i];

          const z = Country.find((i) => i.ID === Number(c));

          const q = State.find((i) => i.ID === Number(c));
          const w = City.find((i) => i.ID === Number(c));

          if (z !== undefined) {
            a.push(z);

            setArrcounrty(a);
          } else if (q !== undefined) {
            s.push(q);

            setArrState(s);
          } else {
            t.push(w);

            setArrCity(t);
          }
        }
        setLocationInfo({
          ...locationInfo,
          sectionID: item.Section_ID,
          LawID: item.Law_ID,
          locationIds: item.LocationIDs,
        });
      } else {
        setLocationInfo({
          ...locationInfo,
          sectionID: item.Section_ID,
          LawID: item.Law_ID,
        });
      }
    } catch (error) {}
  };

  const countryarr = [];
  const statearr = [];
  const cityarr = [];

  const handleFromDate = (date: Date) => {
    setFromDate(jalaliFormat(new Date(date), 'yyyy/MM/dd'));
  };
  const handleToDate = (date: Date) => {
    setToDate(jalaliFormat(new Date(date), 'yyyy/MM/dd'));
  };
  const changeType = (e) => {
    if (e.target.value === 'null') {
      setType('null');
    } else {
      setType(e.target.value);
    }
  };
  const fetchEdit = async () => {
    console.log('first');
    // if(token){
    if (!isTokenExpired(tokenLogin.data?.accessToken)) {
      try {
        await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/Admin/DelsertLocation?sectionId=${locationInfo.sectionID}&lawId=${locationInfo.LawID}&locationIds=${locationInfo.locationIds}`,
          {
            method: 'POST',
            headers: {
              'Content-type': 'application/json',
              Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
            },
          },
        )
          .then((res) => {
            if (res.status === 200) {
              setOpenModal(false);
              if (search !== '') {
                fetchSearchLocation();
              } else {
                FetchLocation(page ? page : 1);
              }
            }
          })
          .catch((error) => console.log(error));
      } catch (error) {
        console.log('error', error);
      }
    } else {
      fetchRefreshToken();
    }
  };

  const handleChangeSelectCounrty = (value) => {
    setValuecountry(value);
    console.log(value);

    value.map((i) => {
      return setStateForSelect(State.filter((item) => item.Parent_ID === i.ID));
    });
  };
  const handleChangeSelectState = (value) => {
    setValueState(value);
    console.log(value);
    value.map((i) => {
      return setCityForSelect(City.filter((item) => item.Parent_ID === i.ID));
    });
  };

  const handleChangeSelectCity = (value) => {
    setValueCity(value);
    value.forEach((i) => {
      countryarr.push(i.ID);
      // const z = (q.join().toString());
    });
    valueState.forEach((i) => {
      statearr.push(i.ID);
    });
    value.forEach((i) => {
      cityarr.push(i.ID);
    });
    const all = [...countryarr, ...statearr, ...cityarr];
    console.log(all.toString());
    setLocationInfo({
      ...locationInfo,
      locationIds: all.toString(),
    });
  };
  const afterpagehandle = async (data: any) => {
    setsearchParams({ page: data.selected + 1 });
    FetchLocation(data.selected + 1);
    // setisLoading(true);
  };
  const changePageSearch = (data: any) => {
    setsearchParams({ page: data.selected + 1 });
    setSearchPage(data.selected + 1);

    fetchSearchLocation();
  };
  const changePageSize = (e) => {
    if (page !== 1 || !page) {
      setsearchParams({});
      setPageSize(parseInt(e.target.value));
    } else {
      setPageSize(parseInt(e.target.value));
    }
  };

  return (
    <>
      <Breadcrumb pageName="توپولوژی" />
      <div className="w-full max-w-full p-10 rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
        <div className="w-full flex items-center justify-between">
          <div className="w-full flex items-center">
            <input
              onChange={(e) => setSearch(e.target.value)}
              value={search}
              className="border-2 w-[90%] relative border-[#E5E1DA] outline-none p-2 rounded-lg m-8 text-[16px]"
              // 
              placeholder="جستجوی قانون"
            />
          </div>
          <div className="w-full rtl flex items-center">
            <div className="w-full  md:mt-0 mt-3 flex items-center ">
              <div className="w-full flex items-center  ">
                <label className="ml-3">از </label>
                <DatePicker
                  className="custom-calendar"
                  inputClass="custom-input"
                  calendarPosition="bottom-center"
                  value={FromDate}
                  locale={persian_fa}
                  calendar={persian}
                  onChange={handleFromDate}
                />
              </div>
            </div>
            <div className="w-full  md:mt-0 mt-3 flex items-center ">
              <div className="w-full flex items-center ">
                <label className="ml-3 mr-3">تا </label>
                <DatePicker
                  className="custom-calendar"
                  inputClass="custom-input"
                  calendarPosition="bottom-center"
                  value={ToDate}
                  locale={persian_fa}
                  calendar={persian}
                  onChange={handleToDate}
                />
              </div>
            </div>
            {/* type */}
            <div className="w-full mr-3 md:mt-0 mt-3 flex items-center ">
              <select
                onChange={changeType}
                className="border w-[90%] relative border-[#E5E1DA] outline-none p-2 rounded-lg text-[14px]"
              >
                <option value="null">نوع</option>
                <option value="1"></option>
                <option value="2"></option>
              </select>
            </div>
          </div>
          <div className="bg-[#FD02] ml-24">
            <button className="button" onClick={fetchSearchLocation}>
              <IoSearchSharp size={35} className="svgIcon " />
            </button>
          </div>
          <div className="w-full font-IranSans">
            <button>
              <span className="box font-IranSans text-[16px]">
                تشخیص هوشمند NER
              </span>
            </button>
          </div>
        </div>

        <div className="w-full mt-3">
          <table className="w-full">
            <thead>
              <tr className="font-IranSans w-full bg-[#B1B2FF] text-[#030637]">
                <th className="w-10 border-b p-3 text-[14px] text-center">
                  ردیف
                </th>
                <th className="w-[30rem] border-b p-3 text-[14px] text-center">
                  متن ماده / تبصره
                </th>
                <th className="w-10 border-b p-3 text-[14px] text-center">
                  توپولوژی
                </th>
              </tr>
            </thead>
            <tbody>
              {SearchResultLocation.length == 0 ? (
                <>
                  {listLocation.map((item: any) => {
                    return (
                      <>
                        <tr>
                          <td className="w-10 border-b p-4 text-[15px] font-IranSans text-center ">
                            {' '}
                            {(rowNumber = rowNumber + 1)}
                          </td>
                          <td className="w-[30rem] border-b p-4 text-[15px] font-IranSans   ">
                            <Link
                              target="_blank"
                              to={`https://ilaw.mrc.ir/ViewText/${item.ID}`}
                            >
                              <div className="font-medium text-black dark:text-white">
                                {deHilight(item.SectionText)}
                              </div>
                            </Link>
                          </td>
                          <td className="w-10  border-b  p-4 font-IranSans text-center">
                            {item.SubjectTitles === null ? (
                              <></>
                            ) : (
                              <div
                                onClick={() => InfoEdit(item)}
                                className="bg-[#38bdf8] text-[15px] font-IranSans w-[100%] p-1 text-[#ffffff] shadow-md rounded-lg cursor-pointer hover:text-[#38bdf8] border hover:border-[#38bdf8] hover:bg-[#ffffff]"
                              >
                                {item.LocationTitles !== null ? (
                                  item.LocationTitles
                                ) : (
                                  <>
                                    <div className="w-full flex items-center justify-center">
                                      <BiSolidEditAlt
                                        size={20}
                                        // className="edit-svgIcon"
                                      />
                                    </div>
                                  </>
                                )}
                              </div>
                            )}
                          </td>
                        </tr>
                      </>
                    );
                  })}
                </>
              ) : (
                <>
                  {SearchResultLocation.map((item: any) => {
                    return (
                      <>
                        <tr>
                          <td className="w-10 border-b p-4 text-[15px] font-IranSans text-center ">
                            {(rowNumber = rowNumber + 1)}
                          </td>
                          <td className="w-[30rem] border-b p-4 text-[15px] font-IranSans  ">
                            <Link
                              target="_blank"
                              to={`https://ilaw.mrc.ir/ViewText/${item.ID}`}
                            >
                              <div className="font-medium text-black dark:text-white">
                                {deHilight(item.SectionText)}
                              </div>
                            </Link>
                          </td>
                          <td className="w-10  border-b  p-4 font-IranSans text-center">
                            {item.SubjectTitles === null ? (
                              <></>
                            ) : (
                              <div
                                onClick={() => InfoEdit(item)}
                                className="bg-[#38bdf8] text-[15px] font-IranSans w-[100%] p-1 text-[#ffffff] shadow-md rounded-lg cursor-pointer hover:text-[#38bdf8] border hover:border-[#38bdf8] hover:bg-[#ffffff]"
                              >
                                {item.LocationTitles !== null ? (
                                  item.LocationTitles
                                ) : (
                                  <>
                                    <div className="w-full flex items-center justify-center">
                                      <BiSolidEditAlt
                                        size={20}
                                        className="edit-svgIcon"
                                      />
                                    </div>
                                  </>
                                )}
                              </div>
                            )}
                          </td>
                        </tr>
                      </>
                    );
                  })}
                </>
              )}
            </tbody>
          </table>
        </div>
        <div className="w-full flex items-center justify-between font-IranSans">
          {SearchResultLocation.length !== 0 ? (
            <>
              <div className="flex w-full items-center ">
                <label className="text-[14px] font-IranSans">
                  تعداد نمایش در صفحه{' '}
                </label>
                <select
                  className="border p-1 mr-3 font-IranSans rounded-lg border-gray-400 outline-none"
                  value={pageSize}
                  onChange={changePageSize}
                >
                  <option value="10">10</option>
                  <option value="30">30</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="300">300</option>
                  <option value="500">500</option>
                  <option value="1000">1000</option>
                </select>
              </div>
              <div className="w-full font-IranSans font-[14px]">
                <ReactPaginate
                  breakLabel={<span className="mr-4 sm:mr-0">...</span>}
                  nextLabel={
                    <span className="w-10 h-10 sm:w-5 sm:h-5 flex items-center justify-center bg-[#D3D3D3] rounded-md mr-4 sm:mr-2 sm:p-2">
                      <BsChevronLeft />
                    </span>
                  }
                  onPageChange={afterpagehandle}
                  pageRangeDisplayed={5}
                  pageCount={Math.ceil(listLocationcount / pageSize)}
                  previousLabel={
                    <span className="w-10 h-10 sm:w-5 sm:h-5 flex items-center justify-center bg-[#D3D3D3] rounded-md">
                      <BsChevronRight />
                    </span>
                  }
                  initialPage={savePage - 1}
                  containerClassName="flex items-center justify-center mt-4 mb-4 flex-wrap"
                  pageClassName="block font-[14px] border- border-solid border-[#D3D3D3] hover:bg-gray-200 w-10 h-10  flex items-center justify-center rounded-md mr-4"
                  activeClassName={
                    savePage ? 'bg-[#06b6d4] text-white hover:text-black' : ''
                  }
                  // current
                />
              </div>
            </>
          ) : (
            <>
              <div className="flex w-full items-center">
                <label className="text-lg font-IranSans">
                  تعداد نمایش در صفحه{' '}
                </label>
                <select
                  className="border p-1 mr-3 font-IranSans rounded-lg border-gray-400 outline-none"
                  onChange={changePageSize}
                >
                  <option value="10">10</option>
                  <option value="30">30</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="300">300</option>
                  <option value="500">500</option>
                  <option value="1000">1000</option>
                </select>
              </div>
              <div className="w-full font-IranSans">
                <ReactPaginate
                  breakLabel={<span className="mr-4 sm:mr-0">...</span>}
                  nextLabel={
                    <span className="w-10 h-10 sm:w-5 sm:h-5 flex items-center justify-center bg-[#D3D3D3] rounded-md mr-4 sm:mr-2 sm:p-2">
                      <BsChevronLeft />
                    </span>
                  }
                  onPageChange={changePageSearch}
                  pageRangeDisplayed={5}
                  pageCount={Math.ceil(SearchResultLocationcount / pageSize)}
                  previousLabel={
                    <span className="w-10 h-10 sm:w-5 sm:h-5 flex items-center justify-center bg-[#D3D3D3] rounded-md">
                      <BsChevronRight />
                    </span>
                  }
                  initialPage={savePage - 1}
                  containerClassName="flex items-center justify-center mt-4 mb-4 flex-wrap"
                  pageClassName="block border- border-solid border-[#D3D3D3] hover:bg-gray-200 w-10 h-10  flex items-center justify-center rounded-md mr-4"
                  activeClassName={
                    savePage ? 'bg-[#06b6d4] text-white hover:text-black' : ''
                  }
                  // current
                />
              </div>
            </>
          )}
        </div>
        {openModal && (
          <div className="ModalBackground">
            <div className="Modal-innerLocation">
              <FaRegWindowClose
                onClick={() => setOpenModal(false)}
                className="mb-2"
                size={25}
              />
              {arrCity.lenght !== 0 &&
              arrState.lenght !== 0 &&
              arrCountry.length !== 0 ? (
                <div className="w-full  border-2 border-[#E5E1DA] rounded-lg p-5">
                  <div className="w-full grid grid-rows-1 gap-10 ">
                    <div className="w-full  items-center justify-center flex ">
                      <label
                        className="ml-5 text-center flex items-center justify-center w-[10%] text-[16px]"
                 
                      >
                        کشور
                      </label>
                      <div className="w-full rtl">
                        <Select
                          style={{
                            fontFamily: 'IranSans',
                            fontSize: '16px',
                            direction: 'rtl',
                            height: '50px',
                          }}
                          options={Country}
                          labelField="Name"
                          valueField="Name"
                          name="select"
                          // multi
                          values={arrCountry}
                          searchable={true}
                          placeholder="کشور"
                          onChange={handleChangeSelectCounrty}
                        />
                      </div>
                      {/* <select className="w-[100%] border-2 mt-5 outline-none border-body p-5 rounded-xl">
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                  </select> */}
                    </div>
                    <div className="w-full  items-center justify-center flex ">
                      <label
                        className="ml-5 text-center flex items-center justify-center w-[10%] text-xl"
                 
                      >
                        استان
                      </label>
                      <div className="w-full rtl">
                        <Select
                          style={{
                            fontFamily: 'IranSans',
                            fontSize: '16px',
                            direction: 'rtl',
                            height: '50px',
                          }}
                          options={StateforSelect}
                          labelField="Name"
                          valueField="Name"
                          name="select"
                          multi
                          values={arrState}
                          searchable={true}
                          placeholder="استان"
                          onChange={handleChangeSelectState}
                        />
                      </div>
                      {/* <select className="w-[100%] border-2 mt-5 outline-none border-body p-5 rounded-xl">
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                  </select> */}
                    </div>

                    <div className="w-full  items-center justify-center flex ">
                      <label
                        className="ml-5 text-center flex items-center justify-center w-[10%] text-xl"
                 
                      >
                        شهر
                      </label>
                      <div className="w-full rtl">
                        <Select
                          style={{
                            fontFamily: 'IranSans',
                            fontSize: '16px',
                            direction: 'rtl',
                            height: '50px',
                          }}
                          options={CityforSelect}
                          labelField="Name"
                          valueField="Name"
                          name="select"
                          multi
                          values={arrCity}
                          searchable={true}
                          placeholder="شهر"
                          onChange={handleChangeSelectCity}
                        />
                      </div>
                      {/* <select className="w-[100%] border-2 mt-5 outline-none border-body p-5 rounded-xl">
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                  </select> */}
                    </div>
                  </div>

                  <div className=" flex gap-5 w-full mt-10 ltr p-5">
                    {/* <button
                  className="w-40 p-2 rounded-lg text-2xl text-white font-bold
                 bg-[#F5564E] hover:border-2 hover:shadow-2xl hover:shadow-black"
                
                >
                  حذف
                </button> */}
                    <button
                      className="w-32 p-2 rounded-full  text-[16px] font-IranSans text-white flex items-center justify-center
                 bg-[#867AE9] font-bold hover:border-2 hover:shadow-2xl hover:shadow-black"
                    
                      onClick={fetchEdit}
                    >
                      تایید <TiTick className="ml-3" />
                    </button>
                    <button
                      className="w-32 p-2 rounded-full flex items-center justify-center text-[16px] font-IranSans hover:border-2 text-white bg-[#65B741] font-bold 
                  hover:shadow-2xl hover:shadow-black "
                    
                    >
                      ثبت
                      <CiEdit size={30} className="ml-2" />
                    </button>
                  </div>
                </div>
              ) : (
                <div className="w-full h-[90%] border-2 border-[#E5E1DA] rounded-lg p-5">
                  <div className="w-full grid grid-rows-1 gap-10 ">
                    <div className="w-full  items-center justify-center flex ">
                      <label
                        className="ml-5 text-center font-IranSans flex items-center justify-center w-[10%] text-[16px]"
                 
                      >
                        کشور
                      </label>
                      <div className="w-full rtl">
                        <Select
                          style={{
                            fontFamily: 'IranSans',
                            fontSize: '16px',
                            direction: 'rtl',
                            height: '50px',
                          }}
                          options={Country}
                          labelField="Name"
                          valueField="Name"
                          name="select"
                          // multi
                          // values={organforEdit}
                          searchable={true}
                          placeholder="کشور"
                          onChange={handleChangeSelectCounrty}
                        />
                      </div>
                      {/* <select className="w-[100%] border-2 mt-5 outline-none border-body p-5 rounded-xl">
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                  </select> */}
                    </div>
                    {StateforSelect.length !== 0 && (
                      <div className="w-full  items-center justify-center flex ">
                        <label
                          className="ml-5 text-center flex items-center justify-center w-[10%] text-[16px]"
                   
                        >
                          استان
                        </label>
                        <div className="w-full rtl">
                          <Select
                            style={{
                                fontFamily: 'IranSans',
                                fontSize: '16px',
                              direction: 'rtl',
                              height: '50px',
                            }}
                            options={StateforSelect}
                            labelField="Name"
                            valueField="Name"
                            name="select"
                            multi
                            searchable={true}
                            placeholder="استان"
                            onChange={handleChangeSelectState}
                          />
                        </div>
                        {/* <select className="w-[100%] border-2 mt-5 outline-none border-body p-5 rounded-xl">
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                  </select> */}
                      </div>
                    )}
                    {CityforSelect.length !== 0 && (
                      <div className="w-full  items-center justify-center flex ">
                        <label
                          className="ml-5 text-center flex items-center justify-center w-[10%] text-[16px]"
                   
                        >
                          شهر
                        </label>
                        <div className="w-full rtl">
                          <Select
                            style={{
                                fontFamily: 'IranSans',
                                fontSize: '16px',
                              direction: 'rtl',
                              height: '50px',
                            }}
                            options={CityforSelect}
                            labelField="Name"
                            valueField="Name"
                            name="select"
                            multi
                            searchable={true}
                            placeholder="شهر"
                            onChange={handleChangeSelectCity}
                          />
                        </div>
                        {/* <select className="w-[100%] border-2 mt-5 outline-none border-body p-5 rounded-xl">
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                  </select> */}
                      </div>
                    )}
                  </div>

                  <div className=" flex gap-5 w-full mt-10 ltr p-5">
                    {/* <button
                  className="w-40 p-2 rounded-lg text-2xl text-white font-bold
                 bg-[#F5564E] hover:border-2 hover:shadow-2xl hover:shadow-black"
                
                >
                  حذف
                </button> */}
                    <button
                      className="w-32 p-2 rounded-full  text-[16px] font-IranSans text-white flex items-center justify-center
                 bg-[#867AE9] font-bold text-[#ffffff] hover:border-2 hover:shadow-2xl "
                    
                      onClick={fetchEdit}
                    >
                      تایید <TiTick className="ml-3" />
                    </button>
                    <button
                      className="w-32 p-2 rounded-full flex items-center justify-center text-[16px] font-IranSans hover:border-2 text-white bg-[#65B741] font-bold 
                  hover:shadow-2xl hover:shadow-black "
                    
                    >
                      ثبت
                      <CiEdit size={20} className="ml-2" />
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}







      </div>
    </>
  );
};

export default NewTopology;
